function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Img from '../common/Img.react';
var SidebarArticle = function SidebarArticle(_ref) {
  var _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    slug = _ref.slug,
    sidebar = _ref.sidebar;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var isActive = function isActive(activeSlug) {
    setActive(slug === activeSlug);
  };
  useEffect(function () {
    $(document).on('slug-update-on-scroll', function (e, activeSlug) {
      return isActive(activeSlug);
    });
    return function () {
      $(document).off('slug-update-on-scroll', function (e, activeSlug) {
        return isActive(activeSlug);
      });
    };
  }, []);
  var title = sidebar.title,
    subtitle = sidebar.subtitle,
    image = sidebar.image,
    location = sidebar.location,
    timeline = sidebar.timeline,
    client = sidebar.client,
    budget = sidebar.budget;
  return /*#__PURE__*/React.createElement("section", {
    id: "sidebar-".concat(slug),
    className: "sidebar-article ".concat(active ? 'sidebar-article__active' : ''),
    onClick: function onClick() {
      if (_onClick) _onClick(slug);
    }
  }, (image === null || image === void 0 ? void 0 : image.filename) && /*#__PURE__*/React.createElement(Img, {
    className: "sidebar-article__img ".concat(active ? 'sidebar-article__img--active' : ''),
    src: "".concat(bucket, "/").concat(image === null || image === void 0 ? void 0 : image.filename),
    alt: image === null || image === void 0 ? void 0 : image.altTag
  }), title && /*#__PURE__*/React.createElement("div", {
    className: "sidebar-article__title",
    id: 'sidebar-title-'
  }, title), subtitle && /*#__PURE__*/React.createElement("div", {
    className: "sidebar-article__sub-title"
  }, subtitle, location && /*#__PURE__*/React.createElement("p", null, location), timeline && /*#__PURE__*/React.createElement("p", null, timeline)), client && /*#__PURE__*/React.createElement("div", {
    className: "sidebar-article__client"
    // style={style}
  }, client, budget && /*#__PURE__*/React.createElement("p", null, budget)), /*#__PURE__*/React.createElement("div", {
    className: "sidebar-article__overlay"
  }), active && /*#__PURE__*/React.createElement("div", {
    id: 'bar-',
    className: "sidebar-article__bar"
  }));
};
export default SidebarArticle;